// Global Actions
export const ACTION_TYPES = {
  // Alert action types
  ALERT: "ALERT",
};

// Profile Actions
export const PROFILE_TYPES = {
  LOADING: "LOADING",
  GET_USER: "GET_USER",
};
